import { render, staticRenderFns } from "./updatePrice.vue?vue&type=template&id=4cb0f8f2&scoped=true"
import script from "./updatePrice.vue?vue&type=script&lang=js"
export * from "./updatePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb0f8f2",
  null
  
)

export default component.exports